// import * as lexAll from "@37signals/lexxy"
// console.log(Object.keys(lexAll));

import { configure } from "@37signals/lexxy"
import { AlignmentExtension } from "./align_ext"
import { LinkedImageExtension } from "./linked_image_ext"
import { NoHighlightExtension } from "./no_highlight_ext"
import { TokenExtension } from "./token_ext"

configure({
  global: {
    extensions: [
      AlignmentExtension,
      LinkedImageExtension,
      NoHighlightExtension,
      TokenExtension
    ]
  }
})
